import { DropOff } from '../../../models/DropOff/DropOff.js';

class DropOffs {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  all(_ref) {
    let {
      city,
      serviceId,
      code,
      zip,
      pointsType
    } = _ref;
    return this.apiClient.get(`v1/dropoffs/${serviceId}/${code}/${zip}`, {
      ...this.apiClient.withRequestContext(),
      city,
      points_type: pointsType
    }).then(response => response.data.map(DropOff.createFromResponse));
  }
  detail(_ref2) {
    let {
      city,
      serviceId,
      code,
      zip,
      pointId,
      pointsType
    } = _ref2;
    return this.apiClient.get(`v1/dropoffs/${serviceId}/${code}/${zip}/${pointId}`, {
      ...this.apiClient.withRequestContext(),
      city,
      points_type: pointsType
    }).then(response => DropOff.createFromResponse(response.data));
  }
}

export { DropOffs };
//# sourceMappingURL=DropOffs.js.map
